<div class="so-pagination-container">
  @if (showText()) {
    <div class="so-pagination-text">
      @if (!loadingItems() || !textParts().parts) {
        {{ textParts().full }}
      } @else {
        <span class="so-pagination-text-part">{{ textParts().parts?.part1 }}</span>
        <span class="so-pagination-spinner"></span>
        <span class="so-pagination-text-part" [class.has-next]="textParts().parts?.part3">{{ textParts().parts?.part2 }}</span>
        @if (textParts().parts?.part3) {
          <span class="so-pagination-spinner"></span>
          <span class="so-pagination-text-part">{{ textParts().parts?.part3 }}</span>
        }
      }
    </div>
  }

  <div class="so-pagination-controls">
    <ul class="so-pagination-list" [style.padding-right]="paddingEnd()">
      <!-- First page -->
      <button
        type="button"
        class="so-pagination-btn so-pagination-btn--icon"
        [class.disabled]="isPrevDisabled()"
        [disabled]="isPrevDisabled()"
        (click)="goToFirstPage()">
        <so-svg-icon-ui name="first_page" [size]="20" color="--so-secondary" />
      </button>

      <!-- Previous page -->
      <button
        type="button"
        class="so-pagination-btn so-pagination-btn--icon"
        [class.disabled]="isPrevDisabled()"
        [disabled]="isPrevDisabled()"
        (click)="goToPreviousPage()">
        <so-svg-icon-ui name="chevron_left" [size]="20" color="--so-secondary" />
      </button>

      <!-- Page n-1 -->
      @if (showPrevPage()) {
        <button
          type="button"
          class="so-pagination-btn"
          [class.disabled]="prevDisabled()"
          [disabled]="prevDisabled()"
          (click)="goToPreviousPage()">
          {{ prevPageNumber() }}
        </button>
      }

      <!-- Current page -->
      <button
        type="button"
        class="so-pagination-btn so-pagination-btn--active">
        {{ internalCurrentPage() }}
      </button>

      <!-- Page n+1 -->
      @if (showNextPage()) {
        <button
          type="button"
          class="so-pagination-btn"
          [class.disabled]="nextDisabled()"
          [disabled]="nextDisabled()"
          (click)="goToNextPage()">
          {{ nextPageNumber() }}
        </button>
      }

      <!-- Next page -->
      <button
        type="button"
        class="so-pagination-btn so-pagination-btn--icon"
        [class.disabled]="isNextDisabled()"
        [disabled]="isNextDisabled()"
        (click)="goToNextPage()">
        <so-svg-icon-ui name="chevron_right" [size]="20" color="--so-secondary" />
      </button>

      <!-- Last page -->
      <button
        type="button"
        class="so-pagination-btn so-pagination-btn--icon"
        [class.disabled]="isNextDisabled()"
        [disabled]="isNextDisabled()"
        (click)="goToLastPage()">
        <so-svg-icon-ui name="last_page" [size]="20" color="--so-secondary" />
      </button>
    </ul>
  </div>
</div>
